<template>
  <div>
    <b-row class="text-uppercase mb-3">

      <b-col md="6" class="mb-2">
        <h5 class="text-primary font-weight-bold mb-3">
          {{$t($getConst.pages.vendor_timesheet_details.vendor_timesheet_details_vendor_name)}}:
          <b-skeleton width="7rem" class="float-right d-inline-flex" v-if="isLoading"></b-skeleton>
          <span v-else class="text-secondary">{{timesheet.sub_contractor_name}}</span>
        </h5>
        <h6 class="mb-3 text-muted font-weight-bold">
          {{$t($getConst.pages.vendor_timesheet_details.vendor_timesheet_details_vendor_gp_id)}}:
          <b-skeleton width="6rem" class="float-right d-inline-flex" v-if="isLoading"></b-skeleton>
          <span v-else class="font-weight-light">{{timesheet.vendor_gp_id}}</span>
        </h6>
        <h6 class="mb-3 text-muted font-weight-bold">
          {{$t($getConst.pages.vendor_timesheet_details.vendor_timesheet_details_assignment_id)}}:
          <b-skeleton width="5rem" class="float-right d-inline-flex" v-if="isLoading"></b-skeleton>
          <span v-else class="font-weight-light">{{timesheet.assignment_id}}</span>
        </h6>
        <h6 class="mb-3 text-muted font-weight-bold">
          {{$t($getConst.pages.vendor_timesheet_details.vendor_timesheet_details_contractor_name)}}:
          <b-skeleton width="6rem" class="float-right d-inline-flex" v-if="isLoading"></b-skeleton>
          <span v-else class="font-weight-light">{{timesheet.contractor_name}}</span>
        </h6>
        <h6 class="mb-3 text-muted font-weight-bold" v-if="timesheet.client_id">
          {{$t($getConst.pages.client.client_name)}}:
          <b-skeleton width="6rem" class="float-right d-inline-flex" v-if="isLoading"></b-skeleton>
          <span v-else class="font-weight-light">{{timesheet.client_id.name}}</span>
        </h6>
      </b-col>

      <b-col md="6">
        <h5 class="text-primary font-weight-bold mb-3">
          {{$t($getConst.pages.vendor_timesheet_details.vendor_timesheet_details_timesheet_status)}}:
          <b-skeleton width="8rem" class="float-right d-inline-flex" v-if="isLoading"></b-skeleton>
          <span v-else class="text-secondary">{{timesheet.timesheet_status}}</span>
        </h5>
        <h6 class="mb-3 text-muted font-weight-bold">
          {{$t($getConst.pages.vendor_timesheet_details.vendor_timesheet_details_timesheet_id)}}:
          <b-skeleton width="5rem" class="float-right d-inline-flex" v-if="isLoading"></b-skeleton>
          <span v-else class="font-weight-light">{{timesheet.timesheet_id}}</span>
        </h6>
        <h6 class="mb-3 text-muted font-weight-bold">
          {{$t($getConst.pages.vendor_timesheet_details.vendor_timesheet_details_week_end_date)}}:
          <b-skeleton width="5rem" class="float-right d-inline-flex" v-if="isLoading"></b-skeleton>
          <span v-else class="font-weight-light">{{formatDate(timesheet.timesheet_week_end_date)}}</span>
        </h6>
        <h6 class="mb-3 text-muted font-weight-bold">
          {{$t($getConst.pages.vendor_timesheet_details.vendor_timesheet_details_submitted_date)}}:
          <b-skeleton width="5rem" class="float-right d-inline-flex" v-if="isLoading"></b-skeleton>
          <span v-else class="font-weight-light">{{formatDate(timesheet.timesheet_submitted_date)}}</span>
        </h6>
        <h6 class="mb-3 text-muted font-weight-bold">
          {{$t($getConst.pages.vendor_timesheet_details.vendor_timesheet_details_approved_date)}}:
          <b-skeleton width="5rem" class="float-right d-inline-flex" v-if="isLoading"></b-skeleton>
          <span v-else class="font-weight-light">{{formatDate(timesheet.timesheet_approved_date)}}</span>
        </h6>
      </b-col>

    </b-row>

    <AppSection
      v-if="isLoading || (timesheet && timesheet.work_days.length)"
      id="timesheet-days"
      type="section"
      :title="$getConst.pages.vendor_timesheet_details.vendor_timesheet_details_days_section_title"
    >
      <b-row class="text-capitalize">
        <template v-if="isLoading">
          <b-col lg="4" md="6" sm="12">
            <b-skeleton-img height="10rem"/>
          </b-col>
          <b-col lg="4" md="6" sm="12">
            <b-skeleton-img height="10rem"/>
          </b-col>
        </template>
        <b-col v-else class="mb-3" lg="4" md="6" sm="12" v-for="(workDay, index) in timesheet.work_days">
          <b-card>
            <h5 class="text-primary font-weight-bold mb-3">
              {{$t($getConst.pages.vendor_timesheet_details.vendor_timesheet_details_day_card_title)}} {{index + 1}}:
            </h5>
            <h6 class="text-muted font-weight-bold">
              {{$t($getConst.pages.vendor_timesheet_details.vendor_timesheet_details_work_date)}}:
              <span class="font-weight-light">{{formatDate(workDay.timesheet_work_date)}}</span>
            </h6>
            <h6 class="text-muted font-weight-bold">
              {{$t($getConst.pages.vendor_timesheet_details.vendor_timesheet_details_day_quantity)}}:
              <span class="font-weight-light">{{workDay.timesheet_day_quantity | removeDecimalIfNotNecessary}}</span>
            </h6>
            <h6 class="text-muted font-weight-bold">
              {{$t($getConst.pages.vendor_timesheet_details.vendor_timesheet_details_earning_code)}}:
              <span class="font-weight-light">{{workDay.timesheet_earning_code}}</span>
            </h6>
            <h6 class="text-muted font-weight-bold">
              {{$t($getConst.pages.vendor_timesheet_details.vendor_timesheet_details_project_id)}}:
              <span class="font-weight-light">{{workDay.project_id}}</span>
            </h6>
          </b-card>
        </b-col>
      </b-row>
    </AppSection>
  </div>
</template>

<script>
  import AppSection from "../../../components/common/sections/AppSection";
  import {formatDateByScope} from "../../../shared/services/date";

  export default {
    name: "VendorTimesheetDetails",
    components: {AppSection},
    props: {
      timesheet: null,
      isLoading: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      formatDate(date) {
        const formatD = formatDateByScope(date, this.$store.getters["auth/scopeDefault"].format_date);
        return formatD;
      },
    }
  }
</script>

<style scoped>
  span {
    margin-left: .5rem;
    float: right;
  }
</style>
